module.exports = __webpack_public_path__ + "img/brand-06.06631893.png";